import { render, staticRenderFns } from "./treatment-step-one.html?vue&type=template&id=55410596&scoped=true&"
import script from "./treatment-step-one.js?vue&type=script&lang=js&"
export * from "./treatment-step-one.js?vue&type=script&lang=js&"
import style0 from "./treatment-step-one.scss?vue&type=style&index=0&id=55410596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55410596",
  null
  
)

export default component.exports